<template>
  <div class="d-flex align-items-center gap-2 mb-2">
    <input
      :value="installment.label"
      type="text"
      class="form-control"
      placeholder="Label (e.g., Deposit)"
      data-cy="installment-label"
      @input="$emit('update:label', ($event.target as HTMLInputElement).value)"
    />
    <div class="input-group" style="max-width: 150px">
      <input
        :value="installment.percentage"
        type="number"
        class="form-control"
        min="0"
        max="100"
        step="1"
        placeholder="0"
        data-cy="installment-percentage"
        @input="
          $emit(
            'update:percentage',
            Math.round(Number(($event.target as HTMLInputElement).value))
          )
        "
      />
      <span class="input-group-text">%</span>
    </div>
    <i
      v-if="removable"
      class="fas fa-trash-alt link text-danger"
      data-cy="remove-installment"
      @click="$emit('remove')"
    />
  </div>
</template>

<script setup lang="ts">
interface Installment {
  label: string;
  percentage: number | null;
  position: number;
  id?: number;
  _destroy?: boolean;
}

defineProps<{
  installment: Installment;
  removable: boolean;
}>();

defineEmits<{
  remove: [];
  "update:label": [value: string];
  "update:percentage": [value: number];
}>();
</script>
